/**
 * 内置弹窗二次确认交互的按钮
 * 大致交互如下：
 * 1、用户点击按钮
 * 2、弹窗二次确认
 * 3、用户点击二次确认弹窗中的confirm按钮，则回调onConfirm，点击cancel按钮则回调onCancel
 */
import classnames from 'classnames';
import React from 'react';
import { ButtonProps, ConfirmOptions, Modal } from 'tea-component';

import type { IBaseProps } from '@home/types/common';

import './index.scss';

interface IConfirmableBtnProps extends Omit<IBaseProps, 'children'>, ButtonProps {
  // 二次确认弹窗标题
  confirmTitle: ConfirmOptions['message'];
  // 二次确认弹窗详细描述
  confirmDescription: ConfirmOptions['description'];
  // Modal.confirm方法的配置
  confirmModalCfg?: ConfirmOptions;
  // 二次确认时，点击confirm的回调
  onConfirm?: () => void;
  // 二次确认时，点击cancel的回调
  onCancel?: () => void;
}

const ConfirmableBtn: React.FC<IConfirmableBtnProps> = (props) => {
  const {
    // 二次确认弹窗标题
    confirmTitle,
    // 二次确认弹窗详细描述
    confirmDescription,
    // Modal.confirm方法的配置
    confirmModalCfg,
    //  按钮内容
    children,
    // 二次确认时，点击confirm的回调
    onConfirm,
    // 二次确认时，点击cancel的回调
    onCancel,
    maskStyle,
  } = props;

  const {
    className: modalClassName,
    okText = 'Confirm',
    cancelText = 'Cancel',
    ...restConfirmModalCfg
  } = confirmModalCfg || {};

  const handleClick = (e?: React.SyntheticEvent<Element>) => {
    e?.stopPropagation();

    Modal.confirm({
      ...restConfirmModalCfg,
      className: classnames('dbg-confirmable-confirm-modal', modalClassName),
      message: confirmTitle,
      description: confirmDescription,
      maskStyle,
      okText,
      cancelText,
      onOk: () => {
        onConfirm?.();
      },
      onCancel: () => {
        onCancel?.();
      },
    });
  };

  if (!React.isValidElement(children)) return null;
  return React.cloneElement(children, {
    ...children?.props,
    className: classnames('dbg-confirmable-operation', children?.props?.className),
    onClick: handleClick,
  });
};

export default React.memo(ConfirmableBtn);
